export const getAuthToken = (state) => state?.auth?.authToken

export const getUser = (state) => state?.auth?.user

export const hasExpiredToken = (state) => state?.auth?.hasExpiredToken
